import {computed,ref,reactive, onMounted} from 'vue'
import {useStore} from 'vuex'

import FilterControls from './FilterComponentControls.vue'

export default {
    name: "FilterComponent",
    components:{
        FilterControls
    },
    props:{
        mobileDrawerContext:{
            default: false
        }
    },
    setup(){
        const store = useStore()
        const facets = computed(()=>store.getters['productSearch/mainFacetsExcluded'])
        const mainFilterFacets = computed(()=>store.getters['productSearch/mainFilterFacets'])
        const selectedFacets = computed(()=>store.getters['productSearch/selectedFacetsOrdered'])
        const filterCount = computed(()=>store.state.productSearch.search_result_max_count)

        const expandedFilters = reactive([])
        const expandFilter = function(index){
            const currentState = !(expandedFilters[index])
            expandedFilters[index] = currentState

        }

        const filterBarExpanded = computed(()=>store.state.productSearch.filterColumnVisible)
        const expandFilterBar = function(){
            store.commit('productSearch/toggleFilterColumnVisilibity', !(filterBarExpanded.value))
        }

        const selectFacet = function(group,facet){
            store.dispatch("productSearch/filterProducts",{
                group:group.name,
                facet:facet.name
            })
        }

        const getLabel = (labelRequested) => {
            return store.getters['labels/getLabel'](labelRequested)
        }

        const closeMobileFilter = ()=> store.commit('main/set_mobile_drawer_component','')

        onMounted(()=>{
            store.dispatch('productSearch/performInitialSearch',{searchString:decodeURI(location.search)})
        })

        return {
            expandFilter,
            expandedFilters,
            expandFilterBar,
            facets,
            filterBarExpanded,
            mainFilterFacets,
            selectFacet,
            selectedFacets,
            getLabel,
            closeMobileFilter,
            filterCount
        }
    }
}